
import Vue from 'vue'
import { Component, PropSync } from 'vue-property-decorator'
import Notification from '@/components/Header/Notification.vue'
import EventCalendar from '@/components/Event/EventCalendar.vue'

@Component({
  components: {
    Notification,
    EventCalendar
  }
})
export default class EventsDrawer extends Vue {
  @PropSync('show', { default: false })
  public showDrawer!: boolean
}
